import React from 'react';
import DatoAsset from '../asset';
const MediaItem = ({ item, className, style, objectFit, objectPosition, autoPlay, muted, isStatic, onPlayStateChange, }) => {
    const media = item?.[0]?.media?.[0] || item?.media?.[0] || null;
    if (!media)
        return null;
    return (React.createElement(DatoAsset, { objectFit: objectFit, objectPosition: objectPosition, className: className, style: style, asset: media.image || media.video || media.externalVideo, autoPlay: autoPlay || media.isInline, muted: muted || media.isInline, thumbnail: media.thumbnail, isStatic: isStatic, onPlayStateChange: onPlayStateChange }));
};
export default MediaItem;
//# sourceMappingURL=index.js.map